var noAccess = [];
/**
 * A temporary id used to properly determine the groups that can edit a resource that is not yet created
 */ var newResourceTempId = "$new$";
export var AccessTableConstants = {
    noAccess: noAccess,
    newResourceTempId: newResourceTempId
};

//# sourceMappingURL=AccessTableConstants.js.map